import React from 'react';
import { withNodeHandles } from './withNodeHandles';
import { NodeData } from '../../store/store';

// Type definitions
interface TableInputContentProps {
  data?: NodeData;
  _type?: string;
}

const TableInputContent: React.FC<TableInputContentProps> = ({ data, _type }) => (
  <span>{data?.label || 'Table Input'}</span>
);

TableInputContent.displayName = 'TableInputContent';

const TableInputNode = withNodeHandles(TableInputContent);
TableInputNode.displayName = 'TableInputNode';

export default TableInputNode;
